import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuthContext } from '../context/AuthContext';
import { hasRole } from './roles';

export default function RequireRole({ roles, fallback = '/403', children }) {
  if (
    process.env.NODE_ENV !== 'production' &&
    roles !== undefined &&
    (!Array.isArray(roles) || roles.length === 0)
  ) {
    // eslint-disable-next-line no-console
    console.warn(
      '[RequireRole] `roles` prop was passed but is empty or not an array — ' +
      'this screen is OPEN to all authenticated users. ' +
      'Did you write `role=` instead of `roles=`?',
    );
  }

  const { auth } = useAuthContext();
  const location = useLocation();

  if (!auth) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (!hasRole(auth?.user?.role, roles)) {
    return <Navigate to={fallback} replace />;
  }

  return children;
}
